import { Component, OnInit,OnDestroy  } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { User } from '../models/user/user';
import { AuthService } from '../services/auth/auth.service';

import { trigger, transition, style, animate } from '@angular/animations';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'dashboard'
    },


    {
      path: '/einkauf',
      title: 'EinKauf',
      type: 'sub',
      icontype: 'shopping_cart',
      collapse: 'einkauf',
      children: [
        {
          path: 'clientdata',
          title: 'Ankauf-Verkauf',
          ab: 'AV'   // badge abbreviation shown in sidebar
        }
      ]
    },
    {
      path: '/warehouseblnc',
      title: 'FremdWarehouse',
      type: 'link',
      icontype: 'dashboard'
  },
  //   {
  //     path: '/clientdata',
  //     title: 'Ankauf-Verkauf',
  //     type: 'link',
  //     icontype: 'swap_horiz'
      
  //  },
    //{
    //     path: '/components',
    //     title: 'Components',
    //     type: 'sub',
    //     icontype: 'apps',
    //     collapse: 'components',
    //     children: [
    //         // {path: 'buttons', title: 'Buttons', ab:'B'},
    //         // {path: 'grid', title: 'Grid System', ab:'GS'},
    //         // {path: 'panels', title: 'Panels', ab:'P'},
    //         // {path: 'sweet-alert', title: 'Sweet Alert', ab:'SA'},
    //         // {path: 'notifications', title: 'Notifications', ab:'N'},
    //         // {path: 'icons', title: 'Icons', ab:'I'},
    //         // {path: 'typography', title: 'Typography', ab:'T'}
    //     ]
    //  },
    //{
    //     path: '/forms',
    //     title: 'Forms',
    //     type: 'sub',
    //     icontype: 'content_paste',
    //     collapse: 'forms',
    //     children: [
    //         {path: 'regular', title: 'Regular Forms', ab:'RF'},
    //         {path: 'extended', title: 'Extended Forms', ab:'EF'},
    //         {path: 'validation', title: 'Validation Forms', ab:'VF'},
    //         {path: 'wizard', title: 'Wizard', ab:'W'}
    //     ]
    // },
    // {
    //     path: '/tables',
    //     title: 'Tables',
    //     type: 'sub',
    //     icontype: 'grid_on',
    //     collapse: 'tables',
    //     children: [
    //         {path: 'regular', title: 'Regular Tables', ab:'RT'},
    //         {path: 'extended', title: 'Extended Tables', ab:'ET'},
    //         {path: 'datatables.net', title: 'Datatables.net', ab:'DT'}
    //     ]
    // }
    // ,{
    //     path: '/maps',
    //     title: 'Maps',
    //     type: 'sub',
    //     icontype: 'place',
    //     collapse: 'maps',
    //     children: [
    //         {path: 'google', title: 'Google Maps', ab:'GM'},
    //         {path: 'fullscreen', title: 'Full Screen Map', ab:'FSM'},
    //         {path: 'vector', title: 'Vector Map', ab:'VM'}
    //     ]
    // },
    // {
    //     path: '/widgets',
    //     title: 'Widgets',
    //     type: 'link',
    //     icontype: 'widgets'

    // },
    // {
    //     path: '/charts',
    //     title: 'Charts',
    //     type: 'link',
    //     icontype: 'timeline'

    // },
    // {
    //     path: '/calendar',
    //     title: 'Calendar',
    //     type: 'link',
    //     icontype: 'date_range'
    // },
    // {
    //     path: '/pages',
    //     title: 'Pages',
    //     type: 'sub',
    //     icontype: 'image',
    //     collapse: 'pages',
    //     children: [
    //         {path: 'pricing', title: 'Pricing', ab:'P'},
    //         {path: 'timeline', title: 'Timeline Page', ab:'TP'},
    //         {path: 'login', title: 'Login Page', ab:'LP'},
    //         {path: 'register', title: 'Register Page', ab:'RP'},
    //         {path: 'lock', title: 'Lock Screen Page', ab:'LSP'},
    //         {path: 'user', title: 'User Page', ab:'UP'}
    //     ]
    // }
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    animations: [
        trigger('slideDown', [
          transition(':enter', [
            style({ opacity: 0, transform: 'translateY(-10px)' }),
            animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
          ]),
          transition(':leave', [
            animate('200ms ease-out', style({ opacity: 0, transform: 'translateY(-10px)' }))
          ])
        ])
      ],
    standalone: false
})

export class SidebarComponent implements OnInit, OnDestroy {
    currentUser: User;
    username:string='';
    currentDate: Date;
    //subscription: Subscription;
    userMenuOpen: boolean = false;
    mobileMenuOpen: boolean = false;
    isMenuOpen: { [key: string]: boolean } = {};
    public menuItems: any[];
    ps: any;
    // isMobileMenu() {
    //     if ($(window).width() > 991) {
    //         return false;
    //     }
    //     return true;
    // };
    private destroy$ = new Subject<void>();
    constructor(
      
        private authService: AuthService,
        
      ) {
      
      }
    ngOnInit() {


        interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.currentDate = new Date();
      });
  
        // const secondsCounter = interval(1000);
        // this.subscription = secondsCounter.subscribe((n) => {
        //     this.currentDate = new Date();
        //   });
        this.currentUser = this.authService.currentUser();
        this.username=this.currentUser.userName
        console.log(this.currentUser);
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
    }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
      }
       /**
   * Check if viewing on mobile
   */
  isMobileMenu(): boolean {
    return window.innerWidth <= 768;
  }
  logout() {
    
    this.authService.logout('logout');
  

}
  /**
   * Toggle user menu dropdown
   */
  toggleUserMenu(): void {
    this.userMenuOpen = !this.userMenuOpen;
  }

  /**
   * Toggle mobile menu
   */
  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  /**
   * Expand or collapse submenu
   */
  
    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    expandOrCollapseMenu(menuId: string): void {
        this.isMenuOpen[menuId] = !this.isMenuOpen[menuId];
      }
    // expandOrCollapseMenu(id){
    //     let parent = document.getElementById(id+ "-p");
    //     let child = document.getElementById(id);
    //     parent.ariaExpanded = parent.ariaExpanded === "true" ? "false" : "true";
    //     child.style.height = child.style.height === "0px" || child.style.height === ""  ? "100%" : "0";
    // }
    
}
